import { Component, OnInit } from '@angular/core';
import {EventsService} from "../../../events.service";
import {GlobalService} from "../../../../global.service";

@Component({
  selector: 'app-player-card',
  templateUrl: './player-card-KSA.component.html',
  styleUrls: ['./player-card-KSA.component.scss']
})
export class TecnoPlayerCardKSAComponent implements OnInit {
  loadIndicator = false
  participants;

  constructor(private eventService: EventsService, public globalService: GlobalService) {
  }

  ngOnInit() {
    this.loadIndicator = true

    this.eventService.getWinnerTournament('tecno-pubg-mobile-cup-2-saudi-arabia' ,'singles').subscribe(res=>{
      this.participants = res.data;
      this.loadIndicator = false
    })
  }

}
